import { MediaLimitationReason } from '@yandex-video-platform/goloom-sdk';

export const hasVideoLimitation = (reason: MediaLimitationReason): MediaLimitationReason | false => {
    return reason !== MediaLimitationReason.NO_LIMITATION && reason !== MediaLimitationReason.UNSPECIFIED && reason;
};
